import React from 'react';
import utfr from '../assests/utfr_web.mp4' // Assuming you have an image file

const SplineInterpolation = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            Spline Interpolation
          </h1>
          <p className="py-6 text-gray-700">
            Task from my time at the Formula Racing Team at UofT.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Background</h2>
          <p className="py-4 text-gray-600">
            The ultimate goal was to provide a racing line for the race car to take.
            The cones mark the circuit, which were used to calculate the midpoint of the track, completed by a teammate.
            I used the new found points and interpolated between the points to create a smooth path.
            Initally bezier curves were used, which were substituted for the more robust cubic splines seen below.
          </p>
          <div className="w-full md:w-full h-auto rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={utfr} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
        </div>
    
      </div>
    </div>
  );
};

export default SplineInterpolation;
